/*
 * ============================================================
 *  PROJETOS — Edite aqui para adicionar seus trabalhos
 * ============================================================
 *
 *  type:
 *    'horizontal' → vídeo widescreen (16:9) do YouTube
 *    'vertical'   → vídeo vertical (9:16) do YouTube / Shorts / Reels
 *    'thumbnail'  → imagem de thumbnail (coloque em public/projects/)
 *
 *  video: 'https://www.youtube.com/embed/SEU_ID'
 *  thumb: '/projects/nome-do-arquivo.jpg'
 *
 * ============================================================
 */

export const horizontalVideos = [
  {
    id: 'h1',
    title: 'A Knight Of The Seven Kingdoms Edit',
    description: 'Edit Of The Series AKOTSK',
    video: 'https://www.youtube.com/embed/su13IgtwXcU',
    thumb: 'https://img.youtube.com/vi/su13IgtwXcU/maxresdefault.jpg',
    tags: ['Premiere', 'Edit', 'Series'],
  },
  {
    id: 'h2',
    title: 'Semi Static Animation - Animation',
    description: 'Original Static Animation',
    video: 'https://www.youtube.com/embed/khDBC0FVeN4',
    thumb: 'https://img.youtube.com/vi/khDBC0FVeN4/maxresdefault.jpg',
    tags: ['Premiere', 'Animation', 'Original'],
  },
  // Adicione mais vídeos horizontais aqui:
  // {
  //   id: 'h2',
  //   title: 'Título do projeto',
  //   description: 'Descrição curta',
  //   video: 'https://www.youtube.com/embed/SEU_ID',
  //   thumb: '/projects/capa.jpg',
  //   tags: ['Premiere'],
  // },
];

export const verticalVideos = [
  {
    id: 'v1',
    title: 'Jhon Snow Edit',
    description: 'Tiktok Edit',
    video: 'https://www.youtube.com/embed/_s6MuTXFIUw',
    thumb: 'https://img.youtube.com/vi/_s6MuTXFIUw/maxresdefault.jpg',
    tags: ['Shorts', 'Reels', 'tiktok'],
  },
  {
    id: 'v2',
    title: 'Real Life Tiktok Edit',
    description: 'Real Life Tiktok edit',
    video: 'https://www.youtube.com/embed/GFW4Fooner4',
    thumb: 'https://img.youtube.com/vi/GFW4Fooner4/maxresdefault.jpg',
    tags: ['Premiere', 'Real Life', 'Original'],
  },
  {
    id: 'v3',
    title: 'Podcast Comic Edit',
    description: 'Podcast Comic Edit',
    video: 'https://www.youtube.com/embed/Waah5NlRuJU',
    thumb: 'https://img.youtube.com/vi/Waah5NlRuJU/maxresdefault.jpg',
    tags: ['Premiere', 'Real Life', 'Podcast'],
  }
  // Adicione mais vídeos verticais aqui
];

export const thumbnails = [
  {
    id: 't1',
    title: 'Thumbnail Copas',
    description: 'Design de thumbnail',
    thumb: '/projects/pro1.png',
    tags: ['Photoshop', 'NanoBanana2'],
  },
  {
    id: 't2',
    title: 'Thumbnail Copas',
    description: 'Design de thumbnail',
    thumb: '/projects/pro2.png',
    tags: ['Photoshop', 'NanoBanana2'],
  },
  {
    id: 't3',
    title: 'Thumbnail Copas',
    description: 'Design de thumbnail',
    thumb: '/projects/pro3.png',
    tags: ['Photoshop', 'NanoBanana2'],
  },
  {
    id: 't4',
    title: 'Thumbnail Copas',
    description: 'Design de thumbnail',
    thumb: '/projects/pro4.png',
    tags: ['Photoshop', 'NanoBanana2'],
  },
  {
    id: 't5',
    title: 'Thumbnail Copas',
    description: 'Design de thumbnail',
    thumb: '/projects/pro5.png',
    tags: ['Photoshop', 'NanoBanana2'],
  },
  {
    id: 't6',
    title: 'Thumbnail Copas',
    description: 'Design de thumbnail',
    thumb: '/projects/pro6.png',
    tags: ['Photoshop', 'NanoBanana2'],
  }
  // Adicione mais thumbnails aqui:
  // {
  //   id: 't3',
  //   title: 'Título',
  //   description: 'Descrição',
  //   thumb: '/projects/arquivo.jpg',
  //   tags: ['Photoshop'],
  // },
];

// Mantido para compatibilidade com SpotlightProject
export const projects = horizontalVideos.map(v => ({
  ...v,
  id: v.id,
  category: 'Edição de Vídeo',
  spotlight: v.id === 'h1',
}));

export const spotlightProject = projects[0];
